import { css } from 'linaria';

export const subtitleTopLineContainer = css`
  width: 100%;
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const subtitleWrapper = css`
  background-color: var(--secondary-white_opacity-4);
  margin-bottom: var(--space-25);
`;

export const subtitleText = css`
  color: var(--secondary-black_opacity-4);
  border: 1px solid var(--control-secondary_opacity-4);
  border-radius: var(--rounding-s);
  padding: var(--space-10) var(--space-60);
`;
